import { takeLatest } from "redux-saga/effects";

import {
  GET_BIRTHDAY_INFO,
  GET_NEW_COLABORATORS_INFO,
  GET_PROFILE_DATA,
  UPDATE_PROFILE_DATA,
} from "../ducks/colaboratorProfile/actionTypes";

import {
  getBirthdayInfo,
  getNewColaboratorsInfo,
  getProfileData,
  updateProfileData,
} from "../ducks/colaboratorProfile/sagas";

export const colaboratorsProfileSagas = [
  takeLatest(GET_BIRTHDAY_INFO, getBirthdayInfo),
  takeLatest(GET_NEW_COLABORATORS_INFO, getNewColaboratorsInfo),
  takeLatest(GET_PROFILE_DATA, getProfileData),
  takeLatest(UPDATE_PROFILE_DATA, updateProfileData),
];
